import type { TransactionFilters } from '../types/transactionTypes'

export const transactionKeys = {
  all: ['transactions'] as const,
  lists: () => [...transactionKeys.all, 'list'] as const,
  list: (filters: TransactionFilters) => [...transactionKeys.lists(), filters] as const,
  details: () => [...transactionKeys.all, 'detail'] as const,
  detail: (transactionId: string) => [...transactionKeys.details(), transactionId] as const,
  filters: () => [...transactionKeys.all, 'filters'] as const,
}
